<template>
	<div class="ml30">

		<!--一级菜单-->
		<div :class="currentMenu == 0 ? 'menu-1-on' : 'menu-1'" @click="onNav('admin-index')">
			<van-icon name="wap-home" size="18px" />
			<span class="ml10">首页</span>
		</div>
		<div :class="currentMenu == 1 ? 'menu-1-on' : 'menu-1'" @click="onShowLeftMenuSecond(0)">
			<van-icon name="comment" size="18px" />
			<span class="ml10">资讯</span>
		</div>
		<el-collapse-transition>
			<div v-show="showLeftMenu[0].show == true">
				<div class="menu-2" @click="onNav('admin-news-ad')">
					发布资讯
				</div>
				<div class="menu-2" @click="onNav('admin-news-list')">
					资讯管理
				</div>
				<div class="menu-2" @click="onNav('admin-news-type')">
					资讯类型管理
				</div>
			</div>
		</el-collapse-transition>
		<div :class="currentMenu == 2 ? 'menu-1-on' : 'menu-1'" @click="onNav('admin-business-type')">
			<van-icon name="shop" size="18px" />
			<span class="ml10">业务管理</span>
		</div>
		<!-- <el-collapse-transition>
			<div v-show="showLeftMenu[1].show == true">
				<div class="menu-2">
					业务类型管理
				</div>
				<div class="menu-2">
					业务管理
				</div>
			</div>
		</el-collapse-transition> -->
		<div :class="currentMenu == 3 ? 'menu-1-on' : 'menu-1'" @click="onNav('admin-hire')">
			<van-icon name="manager" size="18px" />
			<span class="ml10">招聘</span>
		</div>
		<div :class="currentMenu == 4 ? 'menu-1-on' : 'menu-1'" @click="onNav('admin-user')">
			<van-icon name="comment" size="18px" />
			<span class="ml10">用户</span>
		</div>
		<div :class="currentMenu == 5 ? 'menu-1-on' : 'menu-1'" @click="onNav('admin-banner-setting')">
			<van-icon name="comment" size="18px" />
			<span class="ml10">设置</span>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentMenu: 0,
				showLeftMenu: [{
					show: false
				}, {
					show: false
				}],
			}
		},
		created() {

		},
		mounted() {
			var _this = this;
			let val = _this.$cookie.getCurrentMenu();
			_this.currentMenu = val;
			if (_this.currentMenu == 1) {
				_this.showLeftMenu[0].show = true;
			}
		},
		watch: {
			// currentMenu(newVal, oldVal) {
			// 	console.log(newVal, 'watch')
			// }
		},
		methods: {
			onShowLeftMenuSecond(index) {
				var _this = this;
				_this.showLeftMenu[index].show = !_this.showLeftMenu[index].show;
			},
			onNav(name) {
				var _this = this;

				switch (name) {
					case 'admin-index':
						_this.$cookie.setCurrentMenu(0);
						break;
					case 'admin-news-type':
					case 'admin-news-ad':
					case 'admin-news-list':
						_this.$cookie.setCurrentMenu(1);
						break;
					case 'admin-business-type':
						_this.$cookie.setCurrentMenu(2);
						break;
					case 'admin-hire':
						_this.$cookie.setCurrentMenu(3);
						break;
					case 'admin-user':
						_this.$cookie.setCurrentMenu(4);
						break;
					case 'admin-banner-setting':
						_this.$cookie.setCurrentMenu(5);
						break;
				}
				_this.$router.push({
					name: name
				})
			}
		}
	}
</script>

<style>
	.menu-1 {
		width: 240px;
		height: 90px;
		line-height: 90px;
		font-size: 16px;
		text-indent: 30px;
		border-bottom: solid 1px var(--border);
		font-weight: bold;
		color: #666;
		cursor: pointer;
	}

	.menu-1:hover {
		background-color: #ebecf0;
	}

	.menu-1-on {
		width: 240px;
		height: 90px;
		line-height: 90px;
		font-size: 16px;
		text-indent: 30px;
		border-bottom: solid 1px var(--border);
		font-weight: bold;
		color: #d8b86a;
		cursor: pointer;
	}

	.menu-1-on:hover {
		background-color: #ebecf0;
	}

	.menu-2 {
		height: 40px;
		line-height: 40px;
		text-align: left;
		font-size: 16px;
		color: #666;
		margin: 10px auto auto 120px;
		cursor: pointer;
		text-indent: 10px;
		border-radius: 5px;
	}

	.menu-2:hover {
		background-color: #ebecf0;
	}
</style>



// WEBPACK FOOTER //
// src/components/menu-left.vue